export default __webpack_public_path__ + "static/media/mastercard.e5554167.svg";